export default __webpack_public_path__ + "static/media/ios-spinner.min.7e9fe215.svg";